import React, { useState, useEffect, useContext } from "react";
import { API_URL } from "../../components/api";
import { formatDateTime } from "../../../utils/dateFormat";
import {
    DataGrid,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridFooterContainer,
    GridPagination,
} from "@mui/x-data-grid";
import Typography from "@mui/material/Typography";
import ExcelSVG from "./ExcelSVG.svg";
import FilterSVG from "./FilterSVG.svg";
import * as XLSX from "xlsx-js-style";
import Checkbox from "@mui/material/Checkbox";
import CustomizedActions from "./BulkActions";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import AuthContext from "../../context/AuthContext";
import axios from "axios";

import Notes from "./notes";
import ReceiptTable from "./ReceiptsTable";
import Notification from "./SendNotification";
import Cards from "./labels";
import Statement from "./statement";
import "./report.css";

function Imad() { // تغيير اسم الدالة إلى Imad
    const { user } = useContext(AuthContext);

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchQuery, setSearchQuery] = useState("");
    const [Client, setClient] = useState("");
    const [Fullname, setFullname] = useState("");

    const [Cl, setCl] = useState("");
    const [checkedRows, setCheckedRows] = useState([]);
    const [show, setShow] = useState(false);
    const [showNotification, setShowNotification] = useState(false);
    const [showReceipt, setShowReceipt] = useState(false);

    const [showCollectedModal, setShowCollectedModal] = useState(false);
    const [showPostponeModal, setShowPostponeModal] = useState(false);
    const [selectedSubscriptionId, setSelectedSubscriptionId] = useState(null);

    const CloseCollect = () => setShow(false);
    const ShowCollect = () => setShow(true);

    const CloseNotification = () => setShowNotification(false);
    const ShowNotification = () => setShowNotification(true);

    const CloseReceipt = () => setShowReceipt(false);
    const ShowReceipt = () => setShowReceipt(true);

    const ClosePostponeModal = () => setShowPostponeModal(false);
    const ShowPostponeModal = (sub_id) => {
        setSelectedSubscriptionId(sub_id);
        setShowPostponeModal(true);
    };

    const CloseCollectedModal = () => setShowCollectedModal(false);
    const ShowCollectedModal = (sub_id) => {
        setSelectedSubscriptionId(sub_id);
        setShowCollectedModal(true);
    };

    const [showStatement, setShowStatement] = useState(false);

    const CloseStatement = () => setShowStatement(false);
    const ShowStatement = () => setShowStatement(true);

    const [filters, setFilters] = useState({
        status: "",
        fullname_en: "",
        suffix: "",
        balance_usd: "",
        balance: "",
        client_notes: "",
        phone_number: "",
        village_name: "",
        order: "",
        address_string: "",
        payment_date: "",
        due: "",
        expiration_date: "",
        collector: "",
        label: "",
        labels: "",
        note_details: "",
    });
    const [showFilterModal, setShowFilterModal] = useState(false);
    const [gridFilterModel, setGridFilterModel] = useState({
        items: [],
    });

    const [searchInput, setSearchInput] = useState("");
    const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
    const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);

    const handlePostponeConfirm = async () => {
        try {
            const authTokens = JSON.parse(localStorage.getItem("authTokens"));
            await axios.post(
                `${API_URL}/accounting/info/Postpone/`,
                {
                    action: "postpone",
                    sub_id: selectedSubscriptionId,
                    username: user.username,
                },
                {
                    headers: { Authorization: `Bearer ${authTokens.access}` },
                }
            );
            fetchData();
            setShowPostponeModal(false);
        } catch (error) {
            console.error(error);
        }
    };

    const handleCollectedConfirm = async () => {
        try {
            const authTokens = JSON.parse(localStorage.getItem("authTokens"));
            await axios.post(
                `${API_URL}/accounting/info/Collected/`,
                {
                    action: "toBeCollected",
                    sub_id: selectedSubscriptionId,
                    username: user.username,
                },
                {
                    headers: { Authorization: `Bearer ${authTokens.access}` },
                }
            );
            fetchData();
            setShowCollectedModal(false);
        } catch (error) {
            console.error(error);
        }
    };

    const fetchData = async () => {
        try {
            const authTokens = JSON.parse(localStorage.getItem("authTokens"));
            const response = await axios.get(
                `${API_URL}/accounting/info/Collector/`,
                {
                    headers: { Authorization: `Bearer ${authTokens.access}` },
                    params: { username: user.username },
                }
            );

            if (response.status === 200) {
                setData(sortImadRows(response.data));
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [user.username]);

    const getStatusCellStyle = (params) => {
        let statusColor = "";
        switch (params.value) {
            case "offline": statusColor = "status-offline"; break;
            case "online": statusColor = "status-online"; break;
            case "inactive": statusColor = "status-inactive"; break;
            case "expired": statusColor = "status-expired"; break;
            case "hold": statusColor = "status-hold"; break;
            case "HSI": statusColor = "status-hsi"; break;
            default: break;
        }
        return statusColor;
    };

    const [pageSize, setPageSize] = useState(100);
    const [currentPage, setCurrentPage] = useState(0);

    const columns = [
        {
            field: "checkbox",
            headerName: "",
            width: 100,
            renderHeader: () => (
                <Checkbox
                    indeterminate={checkedRows.length > 0 && checkedRows.length < filteredRows.length}
                    checked={checkedRows.length === filteredRows.length && filteredRows.length > 0}
                    onChange={() => {
                        if (checkedRows.length === filteredRows.length) {
                            setCheckedRows([]);
                        } else {
                            setCheckedRows(filteredRows.map((row) => row.subscription_id));
                        }
                    }}
                />
            ),
            renderCell: (params) => (
                <Checkbox
                    className="subcheck"
                    checked={checkedRows.includes(params.row.subscription_id)}
                    onChange={(event) => {
                        const checked = event.target.checked;
                        setCheckedRows((prev) =>
                            checked ? [...prev, params.row.subscription_id] : prev.filter((id) => id !== params.row.subscription_id)
                        );
                    }}
                />
            ),
        },
        { field: "status", headerName: "Status", flex: 2, minWidth: 100, cellClassName: (params) => getStatusCellStyle(params) },
        { field: "fullname_en", headerName: "Full Name", flex: 2, minWidth: 250 },
        { field: "suffix", headerName: "Suffix", flex: 2, minWidth: 100 },
        { field: "balance_usd", headerName: "Balance (USD)", flex: 1, minWidth: 150 },
        { field: "balance", headerName: "Initial Balance", flex: 1, minWidth: 150 },
        { field: "client_notes", headerName: "Client Notes", flex: 1, minWidth: 150 },
        {
            field: "phone_number",
            headerName: "Phone Number",
            flex: 1,
            minWidth: 150,
            renderCell: (params) => {
                let phone = params.row.phone_number;
                if (phone && phone.length === 7) phone = "0" + phone;
                return <span>{phone}</span>;
            }
        },
        { field: "village_name", headerName: "Village", flex: 1, minWidth: 150 },
        { field: "order", headerName: "Village Order", flex: 1, minWidth: 150 },
        { field: "address_string", headerName: "Address", flex: 1, minWidth: 250 },
        {
            field: "payment_date",
            headerName: "Payment Date",
            flex: 1,
            minWidth: 150,
            valueFormatter: (params) => formatDate(params.value)
        },
        { field: "due", headerName: "Due", flex: 1, minWidth: 150 },
        {
            field: "expiration_date",
            headerName: "Expiration Date",
            flex: 1,
            minWidth: 150,
            valueFormatter: (params) => formatDate(params.value)
        },
        { field: "collector", headerName: "Collector", flex: 2, minWidth: 150 },
        { field: "label", headerName: "MC Category", flex: 2, minWidth: 100 },
        {
            field: "labels",
            headerName: "Labels",
            flex: 1,
            minWidth: 120,
            renderCell: (params) => <Cards sub_id={params.row.subscription_id} />
        },
        {
            field: "note_details",
            headerName: "Latest Note",
            flex: 2,
            minWidth: 250,
            valueGetter: (params) => {
                const { note_user, latest_note } = params.row;
                return note_user && latest_note ? `${note_user}: ${latest_note}` : "No Note";
            },
        },
        {
            field: "actions",
            headerName: "Actions",
            minWidth: 700,
            flex: 2,
            renderCell: (params) => (
                <div>
                    <button className="edit-client" onClick={() => { setClient(params.row.subscription_id); setFullname(params.row.fullname_en); ShowCollect(); }}>Notes</button>
                    <button className="edit-client" onClick={() => { setCl(params.row.client_id); ShowReceipt(); }}>Receipt</button>
                    <button className="edit-client" onClick={() => { setClient(params.row.subscription_id); setFullname(params.row.fullname_en); ShowNotification(); }}>Notifications</button>
                    <button className="edit-client postpone-btn" onClick={() => ShowPostponeModal(params.row.subscription_id)}>Postpone</button>
                    <button className="edit-client postpone-btn" onClick={() => ShowCollectedModal(params.row.subscription_id)}>To Be Collected</button>
                    <button onClick={() => { ShowStatement(); setCl(params.row.client_id); }} className="edit-client">Statement</button>
                </div>
            ),
        },
    ];

    const formatDate = (dateString) => {
        if (!dateString) return "";
        return formatDateTime(dateString);
    };

    const handleSearchChange = (event) => {
        const query = event.target.value;
        setSearchInput(query);
        if (searchFilterTimeout) clearTimeout(searchFilterTimeout);
        const newTimeout = setTimeout(() => setSearchQuery(query), 100);
        setSearchFilterTimeout(newTimeout);
    };

    // --- القلتر المعدل لعرض عماد فقط ---
    const filteredRows = data.filter((row) => {
        // 1. عرض فقط "IMAD AL FATAYRI"
        const collectorName = String(row.collector || "").toLowerCase().trim();
        if (!collectorName.includes("imad al fatayri")) return false; // إذا لم يكن عماد، استبعده

        // 2. تصفية الرصيد
        if (Number(row.balance) <= 0) return false;

        // 3. البحث النصي
        const searchMatch = searchQuery.split(" ").every((word) =>
            Object.values(row).some((value) => String(value).toLowerCase().includes(word.toLowerCase().trim()))
        );

        // 4. فلاتر المودال والـ Grid
        const modalFilterMatch = Object.keys(filters).every((key) => {
            if (!filters[key]) return true;
            return String(row[key] || "").toLowerCase().includes(String(filters[key]).toLowerCase());
        });

        return searchMatch && modalFilterMatch;
    });

    const columnHeaders = {
        status: "Status", fullname_en: "Full Name", suffix: "Suffix", village_name: "Village Name",
        balance_usd: "Balance (USD)", balance: "Initial Balance", collector: "Collector", note_details: "Latest Note"
    };

    const IMAD_MIXED_LABEL = "مختلط";

    const imadVillageOrder = (row) => {
        const raw = row ? row.order : null;

        if (raw === null || raw === undefined || raw === "") {
            return null;
        }

        const order = Number(raw);

        return Number.isFinite(order) ? order : null;
    };

    const imadDateRank = (value) => {
        if (!value) {
            return { bucket: 1, key: 0 };
        }

        let text = String(value);

        if (/^\d{4}-\d{2}-\d{2} \d/.test(text)) {
            text = text.replace(" ", "T");
        }

        const date = new Date(text);

        if (Number.isNaN(date.getTime())) {
            return { bucket: 1, key: 0 };
        }

        const day = new Date(
            date.getFullYear(),
            date.getMonth(),
            date.getDate()
        ).getTime();

        return { bucket: 0, key: day };
    };

    const sortImadRows = (rows) => {
        return (rows || [])
            .map((row, index) => ({ row, index }))
            .sort((a, b) => {
                const oa = imadVillageOrder(a.row);
                const ob = imadVillageOrder(b.row);

                if (oa !== ob) {
                    if (oa === null) {
                        return 1;
                    }

                    if (ob === null) {
                        return -1;
                    }

                    return oa - ob;
                }

                const va = String(a.row.village_name || "");
                const vb = String(b.row.village_name || "");

                if (va !== vb) {
                    return va.localeCompare(vb);
                }

                const da = imadDateRank(a.row.payment_date);
                const db = imadDateRank(b.row.payment_date);

                if (da.bucket !== db.bucket) {
                    return da.bucket - db.bucket;
                }

                if (da.key !== db.key) {
                    return da.key - db.key;
                }

                const ca = Number(a.row.client_id) || 0;
                const cb = Number(b.row.client_id) || 0;

                if (ca !== cb) {
                    return ca - cb;
                }

                return a.index - b.index;
            })
            .map((entry) => entry.row);
    };


    const getImadExportFilenameDate = () => {
        const now = new Date();

        const day = String(
            now.getDate()
        ).padStart(2, "0");

        const month = String(
            now.getMonth() + 1
        ).padStart(2, "0");

        const year = now.getFullYear();

        return `${day}-${month}-${year}`;
    };


    const formatImadExportDate = (value) => {
        const raw = String(
            value || ""
        ).trim();

        const match = raw.match(
            /^(\d{4})-(\d{2})-(\d{2})/
        );

        if (!match) {
            return raw;
        }

        return (
            `${match[3]}/${match[2]}/${match[1]}`
        );
    };


    const formatImadExportPhone = (value) => {
        let phone = String(
            value ?? ""
        ).trim();

        /*
         * Same display rule already used by the IMAD
         * DataGrid: Lebanese 7-digit numbers get 0.
         *
         * Always keep the result as TEXT so Excel never
         * removes the leading zero or uses scientific
         * notation.
         */
        if (/^\d{7}$/.test(phone)) {
            phone = `0${phone}`;
        }

        return phone;
    };


    const imadExportDateText = (value) => {
        if (!value) {
            return "";
        }

        let text = String(value);

        if (/^\d{4}-\d{2}-\d{2} \d/.test(text)) {
            text = text.replace(" ", "T");
        }

        const date = new Date(text);

        if (Number.isNaN(date.getTime())) {
            return "";
        }

        const dd = String(date.getDate()).padStart(2, "0");
        const mm = String(date.getMonth() + 1).padStart(2, "0");

        return `${dd}/${mm}/${date.getFullYear()}`;
    };


    const getUniqueImadClients = () => {
        const seen = new Set();
        const unique = [];

        /*
         * Equivalent to Excel Remove Duplicates on
         * client_id: preserve the first occurrence.
         */
        filteredRows.forEach((row) => {
            const key = (
                row.client_id !== null
                && row.client_id !== undefined
            )
                ? `client:${row.client_id}`
                : `subscription:${row.subscription_id}`;

            if (seen.has(key)) {
                return;
            }

            seen.add(key);
            unique.push(row);
        });

        return unique;
    };


    const getImadGroupLabel = (row) => {
        if (imadVillageOrder(row) === null) {
            return IMAD_MIXED_LABEL;
        }

        const arabic = String(
            row.village_name_ar || ""
        ).trim();

        if (arabic) {
            return arabic;
        }

        return String(
            row.village_name || ""
        ).trim() || IMAD_MIXED_LABEL;
    };


    const buildImadExportTemplate = () => {
        const uniqueClients =
            getUniqueImadClients();

        const grouped = new Map();
        const groupOrder = [];

        sortImadRows(uniqueClients).forEach((row) => {
            const label = getImadGroupLabel(row);

            if (!grouped.has(label)) {
                grouped.set(label, []);
                groupOrder.push(label);
            }

            grouped.get(label).push(row);
        });


        /*
         * Matches the accountant's workbook:
         *
         * A = literal 5 from the supplied template
         * B = Initial Balance
         * C = Phone Number
         * D = Address
         * E = Payment Date
         * F = intentionally blank; village separator
         *     rows are merged A:F.
         */
        const rows = [[
            "Name",
            "Initial Balance",
            "Phone Number",
            "Address",
            "Payment Date",
            "",
        ]];

        const groupRows = [];


        groupOrder.forEach(
            (label) => {
                const clients =
                    grouped.get(label);

                if (!clients.length) {
                    return;
                }

                groupRows.push(
                    rows.length
                );

                rows.push([
                    label,
                    "",
                    "",
                    "",
                    "",
                    "",
                ]);


                clients.forEach((row) => {
                    const rawBalance =
                        Number(row.balance);

                    const initialBalance =
                        Number.isFinite(
                            rawBalance
                        )
                            ? rawBalance
                            : (
                                row.balance
                                ?? ""
                            );

                    rows.push([
                        String(
                            row.fullname_en || ""
                        ).trim(),

                        initialBalance,

                        formatImadExportPhone(
                            row.phone_number
                        ),

                        String(
                            row.address_string
                            ?? ""
                        ).trim(),

                        imadExportDateText(
                            row.payment_date
                        ),

                        "",
                    ]);
                });
            }
        );


        return {
            rows,
            groupRows,
            uniqueClientCount:
                uniqueClients.length,
        };
    };


    const downloadImadCsv = (
        csv,
        filename
    ) => {
        const blob = new Blob(
            [
                "\uFEFF",
                csv,
            ],
            {
                type:
                    "text/csv;charset=utf-8;",
            }
        );

        const url =
            URL.createObjectURL(blob);

        const link =
            document.createElement("a");

        link.href = url;
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setTimeout(
            () => URL.revokeObjectURL(url),
            0
        );
    };


    const handleExportToCsv = () => {
        const template =
            buildImadExportTemplate();

        /*
         * CSV cannot store merged cells/fonts/borders,
         * but its CONTENT and grouping are the same
         * as the Excel workbook.
         */
        const csvRows =
            template.rows.map(
                (row) => row.slice(0, 5)
            );

        const worksheet =
            XLSX.utils.aoa_to_sheet(
                csvRows
            );

        const csv =
            XLSX.utils.sheet_to_csv(
                worksheet
            );

        const filename =
            `Imad-${getImadExportFilenameDate()}.csv`;

        downloadImadCsv(
            csv,
            filename
        );
    };


    const handleExportToExcel = () => {
        const template =
            buildImadExportTemplate();

        const worksheet =
            XLSX.utils.aoa_to_sheet(
                template.rows
            );

        const workbook =
            XLSX.utils.book_new();

        const thin = {
            style: "thin",
            color: {
                rgb: "000000",
            },
        };

        const border = {
            top: thin,
            bottom: thin,
            left: thin,
            right: thin,
        };

        const headerStyle = {
            font: {
                bold: true,
            },
            border,
        };

        const groupStyle = {
            font: {
                bold: true,
            },
            fill: {
                patternType: "solid",
                fgColor: {
                    rgb: "D9D9D9",
                },
            },
            alignment: {
                horizontal: "center",
            },
            border,
        };

        const dataStyle = {
            border,
        };

        const groupRowSet = new Set(
            template.groupRows
        );

        for (
            let rowIndex = 0;
            rowIndex < template.rows.length;
            rowIndex += 1
        ) {
            const isGroup = groupRowSet.has(rowIndex);

            for (
                let columnIndex = 0;
                columnIndex < 6;
                columnIndex += 1
            ) {
                const address =
                    XLSX.utils.encode_cell({
                        r: rowIndex,
                        c: columnIndex,
                    });

                if (!worksheet[address]) {
                    worksheet[address] = {
                        t: "s",
                        v: "",
                    };
                }

                const cell = worksheet[address];

                if (
                    rowIndex > 0
                    && !isGroup
                    && (columnIndex === 2 || columnIndex === 4)
                ) {
                    cell.t = "s";
                    cell.v = String(cell.v ?? "");
                    cell.z = "@";
                }

                if (rowIndex === 0) {
                    cell.s = headerStyle;
                } else if (isGroup) {
                    cell.s = groupStyle;
                } else {
                    cell.s = dataStyle;
                }
            }
        }

        worksheet["!cols"] = [
            { wch: 32 },
            { wch: 14 },
            { wch: 14 },
            { wch: 60 },
            { wch: 14 },
            { wch: 4 },
        ];

        worksheet["!merges"] =
            template.groupRows.map(
                (rowIndex) => ({
                    s: {
                        r: rowIndex,
                        c: 0,
                    },
                    e: {
                        r: rowIndex,
                        c: 5,
                    },
                })
            );

        XLSX.utils.book_append_sheet(
            workbook,
            worksheet,
            "Worksheet"
        );

        const filename =
            `Imad-${getImadExportFilenameDate()}.xlsx`;

        XLSX.writeFile(
            workbook,
            filename,
            {
                cellStyles: true,
            }
        );
    };


    return (
        <div className="InternetTable">
            <div className="actions">
                <CustomizedActions subscriptions={checkedRows} deselect={() => setCheckedRows([])} fetch={fetchData} />
                <input type="text" placeholder="Search Imad's clients..." value={searchInput} onChange={handleSearchChange} className="search-client" />
            </div>
            {!loading && (
                <div style={{ height: 570, width: "100%" }}>
                    <DataGrid
                        rows={filteredRows}
                        columns={columns}
                        getRowId={(row) => row.subscription_id}
                        components={{
                            Footer: () => (
                                <GridFooterContainer style={{ display: "flex", justifyContent: "space-between" }}>
                                    <Typography style={{ marginLeft: "16px", color: "white" }}>{`Selected: ${checkedRows.length}`}</Typography>
                                    <GridPagination />
                                </GridFooterContainer>
                            ),
                            Toolbar: () => (
                                <GridToolbarContainer>
                                    <GridToolbarColumnsButton />
                                    <Button onClick={() => setShowFilterModal(true)} variant="outline-primary" style={{ border: "none" }}><img src={FilterSVG} alt="F" style={{ width: "18px", marginRight: "8px" }} /> Filter</Button>
                                    <Button onClick={handleExportToCsv} variant="outline-primary" style={{ border: "none" }}>EXPORT</Button>
                                    <Button onClick={handleExportToExcel} variant="outline-success" style={{ border: "none" }}><img src={ExcelSVG} alt="E" style={{ width: "20px", marginRight: "8px" }} /> Excel</Button>
                                </GridToolbarContainer>
                            ),
                        }}
                        pageSize={pageSize}
                        onPageSizeChange={(s) => setPageSize(s)}
                        rowsPerPageOptions={[10, 100, 1000]}
                        pagination
                        disableSelectionOnClick
                    />
                </div>
            )}

            {/* Modals (نفس مودالات Collector.js مع ربطها ببيانات Imad) */}
            <Modal show={showPostponeModal} onHide={ClosePostponeModal}>
                <Modal.Header closeButton><Modal.Title>Confirm Postpone</Modal.Title></Modal.Header>
                <Modal.Body>Are you sure?</Modal.Body>
                <Modal.Footer><Button variant="primary" onClick={handlePostponeConfirm}>Confirm</Button></Modal.Footer>
            </Modal>

            <Modal show={show} onHide={CloseCollect} className="modal-lg">
                <div className="forma">
                    <Modal.Header closeButton><Modal.Title>{Fullname} Notes</Modal.Title></Modal.Header>
                    <Notes sub_id={Client} />
                </div>
            </Modal>
            {/* ... باقي المودالات من ملف Collector.js ... */}
        </div>
    );
}

export default Imad;